document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('button.btn-copy').forEach(function (button) {
		const targetId = button.getAttribute('data-target');
		const targetElement = document.getElementById(targetId);

		if (!targetElement) {
			return;
		}

		button.addEventListener('click', function () {
			const codeToCopy = targetElement.textContent;

			navigator.clipboard
				.writeText(codeToCopy)
				.then(function () {
					// Update button text to indicate successful copy
					button.textContent = 'Copied!';
					setTimeout(function () {
						button.textContent = 'Copy'; // Reset button text after a delay
					}, 3000); // Reset after 3 seconds
				})
				.catch(function () {
					fallbackCopy(codeToCopy);
				});
		});

		// Accessibility: Set aria-label attribute
		button.setAttribute('aria-label', 'Copy text snippet');
	});
});

// Fallback function for older browsers
function fallbackCopy(text) {
	const textArea = document.createElement('textarea');
	textArea.value = text;
	document.body.appendChild(textArea);
	textArea.select();
	document.execCommand('copy');
	textArea.remove();
}
